/* eslint-disable no-param-reassign */
// this is what @reduxjs/toolkit expects
import { createAction, createReducer } from '@reduxjs/toolkit'

const initialState = {
  isLoading: false,
  isError: null,
  data: null,
  paymentSuccess: false,
}

export const getPurchaseDetail = createAction('purchase/detail')

export const clearPurchaseDetail = createAction('purchase/clear')

export const paymentSuccess = createAction('purchase/payment')

export const purchaseReducer = createReducer(initialState, builder => {
  builder
    .addCase(getPurchaseDetail, (state, action) => {
      state.isError = null
      state.isLoading = false
      state.data = action.payload
    })
    .addCase(clearPurchaseDetail, state => {
      state.isError = null
      state.isLoading = false
      state.data = null
      state.paymentSuccess = false
    })
    .addCase(paymentSuccess, state => {
      state.paymentSuccess = true
    })
})

export const selectPurchaseState = state => state.purchase
